var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition-group',{attrs:{"appear":"","name":_vm.$vuetify.breakpoint.smAndDown ? 'slide-fade-down' : 'slide-fade'}},[(_vm.loading)?_c('div',{key:"loading",staticClass:"text-center mt-16"},[_c('calearna-logo-animation')],1):_c('actions-expansion-panels',{key:"actions",attrs:{"actions":_vm.actions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }